import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row g-2 align-items-center" }
const _hoisted_5 = { class: "col-md-3 col-lg-2" }
const _hoisted_6 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_7 = { class: "col-md-3 col-lg-2" }
const _hoisted_8 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_9 = { class: "col-auto ms-md-auto" }
const _hoisted_10 = { class: "row g-2 mt-2" }
const _hoisted_11 = { class: "col-md-3 col-lg-2" }
const _hoisted_12 = { class: "col-md-3 col-lg-2" }
const _hoisted_13 = { class: "col-md-3 col-lg-2" }
const _hoisted_14 = { class: "col-md-3 col-lg-2" }
const _hoisted_15 = {
  key: 0,
  class: "row m-4 mb-0 mt-0"
}
const _hoisted_16 = { class: "col-sm-12" }
const _hoisted_17 = { class: "card card-body mb-0 text-center text-muted py-3" }
const _hoisted_18 = {
  key: 1,
  class: "row m-4 mb-0 mt-0"
}
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "mb-2 d-flex flex-wrap align-items-center gap-2" }
const _hoisted_21 = { class: "text-muted" }
const _hoisted_22 = { class: "text-muted ms-2" }
const _hoisted_23 = { class: "badge bg-secondary ms-2" }
const _hoisted_24 = { class: "overflow-auto" }
const _hoisted_25 = { class: "table table-bordered align-middle text-left text-nowrap position-relative mb-0" }
const _hoisted_26 = { class: "bg-light" }
const _hoisted_27 = { class: "text-capitalize-first text-end" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "text-capitalize-first" }
const _hoisted_30 = { class: "text-capitalize-first text-end" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "text-capitalize-first text-end" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "text-capitalize-first text-end" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "text-capitalize-first text-end" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "text-capitalize-first text-center" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "text-end" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = { class: "text-end" }
const _hoisted_46 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.requestDTO.fromDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                  mode: "dateTime",
                  "model-modifiers": {string: true},
                  is24hr: "",
                  masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                }, {
                  default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                    _createElementVNode("input", {
                      class: "form-control form-control-sm",
                      placeholder: _ctx.helper.trans('labels.from_date'),
                      value: inputValue,
                      onFocus: togglePopover,
                      onChange: inputEvents.change
                    }, null, 40, _hoisted_6)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.requestDTO.toDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                  mode: "dateTime",
                  "model-modifiers": {string: true},
                  is24hr: "",
                  masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                }, {
                  default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                    _createElementVNode("input", {
                      class: "form-control form-control-sm",
                      placeholder: _ctx.helper.trans('labels.to_date'),
                      value: inputValue,
                      onFocus: togglePopover,
                      onChange: inputEvents.change
                    }, null, 40, _hoisted_8)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"])),
                  class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)), ["prevent"])),
                  class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Multiselect, {
                  class: "multiselect-sm",
                  modelValue: _ctx.cascadesFilter,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cascadesFilter) = $event)),
                  options: _ctx.cascadesOptions,
                  "custom-label": (opt) => opt.name,
                  "track-by": "id",
                  multiple: true,
                  "select-label": "Select",
                  placeholder: _ctx.helper.trans('labels.cascades'),
                  searchable: true,
                  "internal-search": true,
                  "clear-on-select": false,
                  "close-on-select": false,
                  "hide-selected": true
                }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Multiselect, {
                  class: "multiselect-sm",
                  modelValue: _ctx.providersFilter,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.providersFilter) = $event)),
                  options: _ctx.providersOptions,
                  "custom-label": (opt) => `${opt.name} (${opt.sysname})`,
                  "track-by": "id",
                  multiple: true,
                  "select-label": "Select",
                  placeholder: _ctx.helper.trans('labels.providers'),
                  searchable: true,
                  "internal-search": true,
                  "clear-on-select": false,
                  "close-on-select": false,
                  "hide-selected": true
                }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Multiselect, {
                  class: "multiselect-sm",
                  modelValue: _ctx.ratingTypesFilter,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ratingTypesFilter) = $event)),
                  options: _ctx.ratingTypeOptions,
                  "custom-label": _ctx.ratingTypeLabel,
                  multiple: true,
                  "select-label": "Select",
                  placeholder: _ctx.helper.trans('statistic.cascadeRating.rating_type'),
                  searchable: false,
                  "clear-on-select": false,
                  "close-on-select": false,
                  "hide-selected": true
                }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_TrafficGroupMultiselect, {
                  multiple: true,
                  small: "",
                  modelValue: _ctx.trafficGroupsFilter,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ]),
      (!_ctx.response.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.helper.trans('statistic.cascadeRating.no_data')), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (snapshot) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: snapshot.id,
                  class: "card card-body mb-3"
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.helper.trans('statistic.cascadeRating.cascade')) + ":", 1),
                    _createElementVNode("strong", null, _toDisplayString(snapshot.cascade.name), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.helper.trans('statistic.cascadeRating.bucket_date')) + ": " + _toDisplayString(_ctx.formatBucketDate(snapshot.bucketDate)), 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.ratingTypeLabel(snapshot.ratingType)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_26, [
                          _createElementVNode("th", _hoisted_27, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleSnapshotOrderBy(snapshot.id, 'id')), ["prevent"])
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.cascadeRating.provider_id')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa-solid", _ctx.orderByClassForSnapshot(snapshot.id, 'id')])
                              }, null, 2)
                            ], 8, _hoisted_28)
                          ]),
                          _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.helper.trans('statistic.cascadeRating.provider')), 1),
                          _createElementVNode("th", _hoisted_30, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleSnapshotOrderBy(snapshot.id, 'score')), ["prevent"])
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.cascadeRating.score')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa-solid", _ctx.orderByClassForSnapshot(snapshot.id, 'score')])
                              }, null, 2)
                            ], 8, _hoisted_31)
                          ]),
                          _createElementVNode("th", _hoisted_32, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleSnapshotOrderBy(snapshot.id, 'conversion')), ["prevent"])
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.cascadeRating.conversion')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa-solid", _ctx.orderByClassForSnapshot(snapshot.id, 'conversion')])
                              }, null, 2)
                            ], 8, _hoisted_33)
                          ]),
                          _createElementVNode("th", _hoisted_34, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleSnapshotOrderBy(snapshot.id, 'avgTime')), ["prevent"])
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.cascadeRating.avg_time')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa-solid", _ctx.orderByClassForSnapshot(snapshot.id, 'avgTime')])
                              }, null, 2)
                            ], 8, _hoisted_35)
                          ]),
                          _createElementVNode("th", _hoisted_36, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleSnapshotOrderBy(snapshot.id, 'margin')), ["prevent"])
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.cascadeRating.margin')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa-solid", _ctx.orderByClassForSnapshot(snapshot.id, 'margin')])
                              }, null, 2)
                            ], 8, _hoisted_37)
                          ]),
                          _createElementVNode("th", _hoisted_38, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleSnapshotOrderBy(snapshot.id, 'position')), ["prevent"])
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.cascadeRating.position')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa-solid", _ctx.orderByClassForSnapshot(snapshot.id, 'position')])
                              }, null, 2)
                            ], 8, _hoisted_39)
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedProviders(snapshot), (provider) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: provider.id
                          }, [
                            _createElementVNode("td", _hoisted_40, _toDisplayString(provider.id), 1),
                            _createElementVNode("td", null, [
                              _withDirectives((_openBlock(), _createElementBlock("span", {
                                title: provider.sysname
                              }, [
                                _createTextVNode(_toDisplayString(provider.name || provider.sysname), 1)
                              ], 8, _hoisted_41)), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.formatMetric(provider.score)), 1),
                            _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatConversion(provider.conversion)), 1),
                            _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.formatAvgTime(provider.avgTime)), 1),
                            _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.formatMetric(provider.margin)), 1),
                            _createElementVNode("td", _hoisted_46, _toDisplayString(provider.position), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.response.totalCount > _ctx.response.items.length)
                ? (_openBlock(), _createBlock(_component_b_pagination, {
                    key: 0,
                    modelValue: _ctx.page,
                    "onUpdate:modelValue": [
                      _cache[8] || (_cache[8] = ($event: any) => ((_ctx.page) = $event)),
                      _cache[9] || (_cache[9] = ($event: any) => (_ctx.load()))
                    ],
                    "total-rows": _ctx.response.totalCount,
                    "per-page": _ctx.response.limit,
                    limit: 20,
                    "prev-text": "Back",
                    "next-text": "Next",
                    align: "start",
                    "first-number": "",
                    "hide-goto-end-buttons": "",
                    "hide-ellipsis": ""
                  }, null, 8, ["modelValue", "total-rows", "per-page"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }, 512))
}